import React, { useState } from 'react'
import {loadStripe} from '@stripe/stripe-js';
import firebase from 'firebase/app';
import { Button, Spinner } from '@blueprintjs/core';

function Add500Tokens({
    auth
}) {

    const [showSpinner, setShowSpinner] = useState(false)
 
    const handleSubmit = async() =>{
              var db = firebase.firestore();
              const stripe = await loadStripe('pk_live_51IQM49DGIrW588V8peopeSILQL0Dh4Bzpv9jSadT1UvsP01cyG9UbSCFqoWMplVSbl1TE6P7pcwSrLTuGKrUTNhO00ptV0a3vv');
              setShowSpinner(true)
    
              var docRef =
                  await db.collection('customers')
                  .doc(auth.uid)
                  .collection('checkout_sessions')
                  .add({
                    price: 'price_1IY2m8DGIrW588V83YOKD9jU',
                    success_url: window.location.origin,
                    cancel_url: window.location.origin,
                    metadata: {
                      tokens: 500,
                      tokensAdded: 'no'
                    },
                    IdempotencyKey: "XBKifMkKaHzdvSnm",
                  })
          
              docRef.onSnapshot((snap) =>{
                  const {error, sessionId } = snap.data();
                  if (error) {
                    alert(`An error occured: ${error.message}`);
                  } 
                  if ( sessionId ) stripe.redirectToCheckout({ sessionId });
                  console.log(snap.data())
                  console.log(sessionId)
                })
      }    

    return (
        <div>
            <Button 
            onClick={handleSubmit}
            icon='credit-card'
                // intent='primary'
                style={{
                    marginTop: 20
                }}
            >
                Subscribe Today!
            </Button>
            {showSpinner ?
            <div
            style={{
              marginTop: 10
            }}
            >
              <Spinner /> 
              <br></br>
              Sending to Stripe for Payment
            </div>   
            : null}
        </div>
    )
}

export default Add500Tokens
